// extracted by mini-css-extract-plugin
export var active = "_ft-7";
export var blink = "_ft-8";
export var dropDownSelector = "_ft-4";
export var dropDownWrapper = "_ft-3";
export var fakeCursor = "_ft-6";
export var fontSizeButton = "_ft-9";
export var formQuillEditor = "_ft-0";
export var pressed = "_ft-a";
export var qlBlank = "_ft-1";
export var textFormattingToolbar = "_ft-2";
export var textToolbarOption = "_ft-5";